import { Injectable } from '@angular/core';
import { ComponentHeader } from '../models/componentheader.model';
import { BreadCrumb } from '../models/breadcrumb.model';
import { HeaderButton } from '../models/headerbtn.model';
import { AdminAction } from '../models/adminaction.model';
import { Title } from '@angular/platform-browser';
import { UtilService } from './util.service';
import { SchoolmanagementService } from './schoolmanagement.service';

@Injectable({
  providedIn: 'root'
})
export class ComponentheaderService {
  public headerDisplay = new ComponentHeader();
  pageloading: boolean = false;
  fakeloadinginterval;
  //schools: any = {};
  //school: any = {};
  taketour:boolean=false;
  //private util;
  constructor(private util: UtilService, private schoolmanager: SchoolmanagementService, private title: Title) {
    //this.util = new UtilService(this);
   }

   //setHeaderDisplay(maintitle :string, breadcrumbs : BreadCrumb[], buttons : HeaderButton[]){
    async setHeaderDisplay(maintitle :string, breadcrumbs : BreadCrumb[], adminactions: AdminAction[],touroptions:any[]=[]){
      
    this.headerDisplay.maintitle = maintitle;
    //this.headerDisplay.subtitle = subtitle;
    this.headerDisplay.breadcrumbs = breadcrumbs;
    this.headerDisplay.adminactions = adminactions;
    this.headerDisplay.touroptions=touroptions;
    await this.setPageTitle(maintitle);
    
    //this.headerDisplay.buttons = buttons; 
   }

   setLoadingProgress(progressPercentage: number){
    this.headerDisplay.loadingprogress = progressPercentage;
   }

  //  async loadSchool(subdomain: string){
  //   if(!this.school.schoolName){
  //     this.school = await this.getSchool(subdomain);
  //     //const schoolinfo = await this.getSchool(subdomain);
      

  //     // if(this.school.logoCustomization)
  //     // {
  //     //   const icon = document.querySelector('[rel="icon"]');
  //     //   icon.setAttribute('href', this.school.logoImg);
  //     //   console.log(icon)
  //     // }
  //    }
     
  //  }

   async setPageTitle(title: string){
    //can't use dependency injection because of cyclick redundancy
   let schoolname = (await this.util.getStaticSchoolInfoBundle()).schoolInfo.schoolName;
   
  //  if(subdomain){
  //    await this.loadSchool(subdomain);
  //    schoolname = this.school.schoolName;
  //  }
  //  else{
  //    //switching subdomains will require a full page load anyway, so no need to keep setting the favicon
  //    this.school = {};
  //    schoolname = 'Impata';
  //  }

   this.title.setTitle(`${schoolname} - ${title}`);
  }

  // async getSchool(subdomain: string){
  //   if(!this.schools[subdomain]){
  //     this.schools[subdomain] = await this.schoolmanager.getSchoolFromSubdomain().toPromise();
  //    }
  //    const schoolinfo: any = this.schools[subdomain];
  //    return schoolinfo;
  // }

  pageLoadingStarted(component: any,hidepagecontent:boolean=true){
    this.pageloading = true;
    let progress = 10;
    const mythis = this;
    this.fakeloadinginterval = setInterval(() => {
      if(progress <= 80){
        progress += 10;
        mythis.setLoadingProgress(progress);
      }
    }, 200);
    if(hidepagecontent){
    this.showHidePage(component, false);}
  }

  pageLoadingDone(component: any){
    //debugger;
    this.showHidePage(component, true);
    clearInterval(this.fakeloadinginterval);
    this.setLoadingProgress(95);
    const mythis = this;
    setTimeout(() => {
      mythis.setLoadingProgress(0);
      mythis.pageloading = false;  
    }, 200);
  }

  pageLoadingError(){
    //debugger;
    clearInterval(this.fakeloadinginterval);
    this.setLoadingProgress(0);
  }

  private showHidePage(component: any, show: boolean){
    if(component.hidewhenloading){
      if(typeof component.hidewhenloading.forEach !== 'undefined')
      {
        component.hidewhenloading.forEach(element => {
          $(element.nativeElement).css('opacity', show ? '1' : '0');
        });
      } else{
        $(component.hidewhenloading.nativeElement).css('opacity', show ? '1' : '0');
      }
    }
  }
}
